//#####################################################################################################
//# DIGITAL SOFTWARE WORKS JAVASCRIPTS
//#####################################################################################################

import $ from 'jquery'

// window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');
import * as bootstrap from 'bootstrap'

// import 'jquery-mask-plugin'

// var Decimal = require('decimal.js-light');

(function($) {
  "use strict";
  $(document).ready(function() {init();});

  const init = function() {
    ajax_error_handler();
    set_overlayables($('.overlayable'));
    set_pagination_overlayables($('.pagination.pagination-overlayable'));
    close_flash_notice_alert();
    init_modal_reset();
    init_filter_panel();
    set_anchor_modalables();

    // reset_maskable_phones();
  };

})(jQuery);

//#####################################################################################################
// AJAX ERROR HANDLER
//#####################################################################################################

const ajax_error_handler = function() {
  $(document).on("ajax:error", function(event) {
    const detail = event.detail;
    const data = detail[0], status = detail[1],  xhr = detail[2];
    console.log(status);
    console.log(xhr);

    if (confirm("Error. Reload the page.\n\"" + status + "\"")) location.reload();
  });
}

//#####################################################################################################
// SLIDE UP NOTICE ALERT
//#####################################################################################################

const close_flash_notice_alert = function() {
  const $flash_notice_alert = $('#flash_notice_alert');
  setTimeout( function() { $flash_notice_alert.slideUp(); }, $flash_notice_alert.data('display_milliseconds'));
}

//#####################################################################################################
// OVERLAY
//#####################################################################################################

window.show_overlay = function() {
  $('#overlay').show();
}

window.hide_overlay = function() {
  $('#overlay').fadeOut('fast');
}

window.set_form_overlayables = function($form) {
  $form.submit(function() {
    $('#overlay').show();
  });
}

window.set_overlayables = function($element) {
  $element.click(function() {
    $('#overlay').show();
  });
}

window.set_pagination_overlayables = function($element) {
  $element.find('a').click(function() {
    $('#overlay').show();
  });
}

//#####################################################################################################
// MODAL
//#####################################################################################################

const set_anchor_modalables = function() {
  $('a.modalable').click(function() {
    show_modal($(this));
  });
}

// modal title setup
window.set_modal_title = function(html) {
  $('#modal .modal-header .modal-title').html(html);
}

window.set_modal_body = function(html) {
  $('#modal .modal-body:first').html(html);
}

// modal click trigger setup
window.set_modalables = function($element) {
  $element.click(function() {
    show_modal($(this));
  });
}

window.show_modal = function($element) {
  const $modal_dialog = $('#modal .modal-dialog'),
        $modal_header = $('#modal .modal-header'),
        $modal_body = $('#modal .modal-body'),
        $modal_footer = $('#modal .modal-footer');

  // hide header and footer
  if ($element.hasClass('modal-no-header')) $modal_header.hide();
  if ($element.hasClass('modal-no-footer')) $modal_footer.hide();

  // adjust size
  if ($element.hasClass('modal-sm')) $modal_dialog.addClass('modal-sm');
  if ($element.hasClass('modal-md')) $modal_dialog.addClass('modal-md');
  if ($element.hasClass('modal-lg')) $modal_dialog.addClass('modal-lg');
  if ($element.hasClass('modal-xl')) $modal_dialog.addClass('modal-xl');

  let options = {}

  // backdrop static
  if ($element.hasClass('modal-backdrop-static')) options.backdrop = 'static';

  // keyboard false
  if ($element.hasClass('modal-keyboard-false')) options.keyboard = false;

  // set spinner
  $modal_body.html($('#overlay').html());

  const $modal = new bootstrap.Modal('#modal', options);

  $modal.show(options);
}

// reset modal
const init_modal_reset = function() {
  const $modal = $('#modal');
  if ($modal.length) {
    $modal[0].addEventListener('hidden.bs.modal', function(e) {
      const $modal_dialog = $modal.find('.modal-dialog'),
            $modal_header = $modal.find('.modal-header'),
            $modal_footer = $modal.find('.modal-footer');

      // content reset
      if ($modal_header.is(':hidden')) $modal_header.show();
      if ($modal_footer.is(':hidden')) $modal_footer.show();
      $('#modal .modal-body').html('&nbsp;');
      set_modal_title('&nbsp;');

      // size reset
      if ($modal_dialog.hasClass('modal-sm')) $modal_dialog.removeClass('modal-sm');
      if ($modal_dialog.hasClass('modal-md')) $modal_dialog.removeClass('modal-md');
      if ($modal_dialog.hasClass('modal-lg')) $modal_dialog.removeClass('modal-lg');
      if ($modal_dialog.hasClass('modal-xl')) $modal_dialog.removeClass('modal-xl');

      // data reset
      $modal.data('bs.modal', null);
    })
  }
}

//#####################################################################################################
//# FILTER PANEL
//#####################################################################################################

const init_filter_panel = function() {
  if ($('div#filter_panel').length) {
    $('div#filter_panel > div:first').click(function() {
      if ($('div#filter_panel > div.expanded:first').length) {
        $('div#filter_panel > div#expandable').slideUp('fast', function() {
          $('div#filter_panel > div:first').removeClass('expanded');
        });
      } else {
        $('div#filter_panel > div#expandable').slideDown('fast', function() {
          $('div#filter_panel > div:first').addClass('expanded');
        });
      }
    });
  }
}

// //#####################################################################################################
// //# MASK PHONE
// //#####################################################################################################

// window.reset_maskable_phones = function() {
//   $('.maskable-phone').unmask().mask('(000) 000-0000');
// }

// //#####################################################################################################
// //# FORMAT INPUT PRICE
// //#####################################################################################################

// window.format_input_price = function() {
//   $('input[type="number"].formatable-input-price').each(function() {
//     const val = $.trim($(this).val());
//     if (val) {
//       const decimaled = new Decimal(val);
//       $(this).val(decimaled.toFixed(2));
//     }
//   });
// }
